import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

/**
 * Funcionalidade: Lista de transmissão de WhatsApp
 * Retorna todas as listas de transmissões criadas por um agente
 * @requestType GET
 * @param {*} agentId
 * @returns json
 */
export const getBroadcastWhatsAppList = (agentId) =>
  http.get(`/broadcast/whatsapp/agent/${agentId}`).then(handleResponse);

/**
 * Funcionalidade: Lista de transmissão de WhatsApp
 * Cancela uma lista de transmissão de whatsapp
 * @requestType PUT
 * @param {*} params // {agentId,broadcastListId}
 * @returns json
 */
export const cancelBroadcastWhatsApp = (params) =>
  http.put('/broadcast/whatsapp/cancel', params).then(handleResponse);

/**
 * Funcionalidade: Lista de transmissão de WhatsApp
 * Cria uma nova lista de transmissão
 * @requestType POST
 * @param {*} params
 * @returns json
 */
export const newBroadcastWhatsApp = (params) =>
  http.post('/broadcast/whatsapp', params).then(handleResponse);
